document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.store-near-you');
    if (!section) return;

    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const cityTabs = section.querySelectorAll('[data-city-filter]');
    const tabsContainer = document.getElementById('store-city-tabs');
    const searchInput = document.getElementById('store-near-you-input');
    const searchClearButton = document.getElementById('store-near-you-clear');
    const storeListings = document.getElementById('store-listings');
    const storeItems = storeListings ? Array.from(storeListings.querySelectorAll('.store-item')) : [];
    const pincodeWarning = section.querySelector('[data-pincode-warning]');
    const emptyState = section.querySelector('[data-empty-state]');

    const SEARCH_DEBOUNCE_MS = 300;
    const PINCODE_NEIGHBOR_RANGE = 5000;
    const COORD_NEIGHBOR_DELTA = 0.09;

    let currentCity = 'all';
    let currentSearch = '';
    let searchDebounceTimer;

    const activeTab = Array.from(cityTabs).find(
        (tab) => tab.getAttribute('data-city-active') === 'true'
    );
    if (activeTab) currentCity = activeTab.dataset.cityFilter || 'all';
    if (searchInput) currentSearch = searchInput.value.trim().toLowerCase();

    const containsDigit = (value) => /\d/.test(value);

    const updateClearButton = () => {
        if (!searchClearButton || !searchInput) return;
        if (searchInput.value.trim() === '') {
            searchClearButton.classList.add('hidden');
        } else {
            searchClearButton.classList.remove('hidden');
        }
    };

    const scrollTabIntoView = (tab) => {
        if (!tabsContainer) return;
        const containerRect = tabsContainer.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const isFullyVisible = tabRect.left >= containerRect.left && tabRect.right <= containerRect.right;
        if (!isFullyVisible) {
            tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    };

    const updateActiveTab = (city) => {
        cityTabs.forEach((tab) => {
            const isMatch = tab.dataset.cityFilter === city;
            if (isMatch) {
                tab.classList.remove('bg-white', 'text-black', 'hover:bg-gray-100');
                tab.classList.add('bg-black', 'text-white');
                tab.setAttribute('data-city-active', 'true');
                scrollTabIntoView(tab);
            } else {
                tab.classList.remove('bg-black', 'text-white');
                tab.classList.add('bg-white', 'text-black', 'hover:bg-gray-100');
                tab.setAttribute('data-city-active', 'false');
            }
        });
    };

    const findReferencePincodes = (searchPincode) => {
        const referencePincodes = new Set();
        const searchNum = parseInt(searchPincode, 10);
        if (Number.isNaN(searchNum)) return referencePincodes;

        for (const item of storeItems) {
            const pincode = item.dataset.storePincode || '';
            const pincodeNum = parseInt(pincode, 10);
            if (Number.isNaN(pincodeNum)) continue;
            const diff = Math.abs(pincodeNum - searchNum);
            if (diff > 0 && diff <= PINCODE_NEIGHBOR_RANGE) {
                if (item.dataset.storeLat && item.dataset.storeLng) {
                    referencePincodes.add(pincode);
                }
            }
        }
        return referencePincodes;
    };

    const isNearReferenceStore = (item, referencePincodes) => {
        const lat = parseFloat(item.dataset.storeLat);
        const lng = parseFloat(item.dataset.storeLng);
        if (Number.isNaN(lat) || Number.isNaN(lng)) return false;

        for (const refItem of storeItems) {
            const refPincode = refItem.dataset.storePincode || '';
            if (!referencePincodes.has(refPincode)) continue;
            const refLat = parseFloat(refItem.dataset.storeLat);
            const refLng = parseFloat(refItem.dataset.storeLng);
            if (Number.isNaN(refLat) || Number.isNaN(refLng)) continue;

            const latDiff = Math.abs(lat - refLat);
            const lngDiff = Math.abs(lng - refLng);
            if (latDiff <= COORD_NEIGHBOR_DELTA && lngDiff <= COORD_NEIGHBOR_DELTA) {
                return true;
            }
        }
        return false;
    };

    const matchesTextSearch = (item, query) => {
        const title = item.dataset.storeTitle || '';
        const address = item.dataset.storeAddress || '';
        const city = item.dataset.storeCity || '';
        const pincode = (item.dataset.storePincode || '').toLowerCase();
        const state = item.dataset.storeState || '';
        return (
            title.includes(query) ||
            address.includes(query) ||
            city.includes(query) ||
            pincode.includes(query) ||
            (state !== '' && state.includes(query))
        );
    };

    const applyFilters = () => {
        const isPincode = currentSearch !== '' && containsDigit(currentSearch);
        const searchPincode = isPincode ? currentSearch.replace(/[\s-]/g, '') : '';

        let hasExactPincodeMatch = false;
        let referencePincodes = new Set();
        if (isPincode && searchPincode) {
            hasExactPincodeMatch = storeItems.some(
                (item) => (item.dataset.storePincode || '') === searchPincode
            );
            if (!hasExactPincodeMatch) {
                referencePincodes = findReferencePincodes(searchPincode);
            }
        }

        let visibleCount = 0;
        let firstVisibleItem = null;

        for (const item of storeItems) {
            let shouldShow = true;

            if (currentCity && currentCity !== 'all' && item.dataset.storeCity !== currentCity) {
                shouldShow = false;
            }

            if (shouldShow && currentSearch !== '') {
                if (isPincode) {
                    const isExact = (item.dataset.storePincode || '') === searchPincode;
                    const isNearby = !hasExactPincodeMatch
                        && referencePincodes.size > 0
                        && isNearReferenceStore(item, referencePincodes);
                    if (!isExact && !isNearby) shouldShow = false;
                } else if (!matchesTextSearch(item, currentSearch)) {
                    shouldShow = false;
                }
            }

            if (shouldShow) {
                item.classList.remove('hidden');
                visibleCount += 1;
                if (!firstVisibleItem) firstVisibleItem = item;
            } else {
                item.classList.add('hidden');
            }
        }

        if (emptyState) {
            emptyState.classList.toggle('hidden', visibleCount > 0);
        }

        if (pincodeWarning) {
            const showWarning = isPincode && !hasExactPincodeMatch && visibleCount > 0;
            pincodeWarning.classList.toggle('hidden', !showWarning);
            pincodeWarning.classList.toggle('flex', showWarning);
        }

        if (firstVisibleItem) {
            const firstTrigger = firstVisibleItem.querySelector('[data-accordion-trigger]');
            if (firstTrigger && firstTrigger.getAttribute('aria-expanded') !== 'true') {
                firstTrigger.click();
            }
        }
    };

    const updateUrl = () => {
        const url = new URL(window.location.href);
        if (currentCity && currentCity !== 'all') {
            url.searchParams.set('city', currentCity);
        } else {
            url.searchParams.delete('city');
        }
        if (currentSearch !== '') {
            url.searchParams.set('search', currentSearch);
        } else {
            url.searchParams.delete('search');
        }
        window.history.replaceState({}, '', url.toString());
    };

    cityTabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const city = tab.dataset.cityFilter;
            if (city === currentCity && tab.getAttribute('data-city-active') === 'true') return;

            currentCity = city;

            if (currentSearch !== '') {
                currentSearch = '';
                if (searchInput) searchInput.value = '';
                updateClearButton();
            }

            updateActiveTab(city);
            applyFilters();
            updateUrl();
        });
    });

    if (searchInput) {
        searchInput.addEventListener('input', () => {
            const query = searchInput.value.trim().toLowerCase();
            currentSearch = query;
            updateClearButton();

            if (query !== '') {
                currentCity = 'all';
                updateActiveTab('all');
            }

            clearTimeout(searchDebounceTimer);
            searchDebounceTimer = setTimeout(() => {
                applyFilters();
                updateUrl();
            }, SEARCH_DEBOUNCE_MS);
        });

        searchInput.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            clearTimeout(searchDebounceTimer);
            applyFilters();
            updateUrl();
        });
    }

    if (searchClearButton) {
        searchClearButton.addEventListener('click', () => {
            if (!searchInput) return;
            searchInput.value = '';
            currentSearch = '';
            updateClearButton();
            applyFilters();
            updateUrl();
        });
    }

    if (currentSearch !== '') {
        applyFilters();
    }
});
